








import {Component, Vue} from 'vue-property-decorator';
import {Action} from 'vuex-class';
import ImageLayout from '@/components/ImageLayout.vue';

@Component({
  components: {
    ImageLayout,
  },
})
export default class AccountNotActivated extends Vue {
  @Action('sendActivationLink') protected sendActivationLinkAction: any;

  protected handleClick() {
    this.sendActivationLinkAction();
  }
}
